import { queryOptions } from '@tanstack/react-query';

import * as ApiClient from '../api-client';

export const referralMany = () => {
  const { queryKey, queryFn } = queryOptions({
    queryKey: ['referral'],
    queryFn: ApiClient.getMany,
  });

  return {
    queryKey,
    queryFn,
  };
};
